(function ($) {
  pcgAwardPressQuoteV1 = {
    formatter: $('.pcg-award-press-quote-v1')
  };

  Drupal.behaviors.pcgAwardPressQuoteV1 = {
    get: function (key) {
      return pcgAwardPressQuoteV1[key];
    },

    set: function (key, val) {
      pcgAwardPressQuoteV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        thisFormatter.closest('.flexslider').addClass('award-press');
        thisFormatter.closest('.flexslider.award-press').css({
          'margin-bottom': '15px',
          'padding-bottom': '15px'
        });
        thisFormatter.find('.quote p span').css({ 'line-height': thisFormatter.find('.quote p span').css('font-size') });
        if (thisFormatter.find('.bg-color').attr('data-bg-color') !== '#') {
          var bgColor = thisFormatter.find('.bg-color').attr('data-bg-color');

          thisFormatter.closest('.flexslider.award-press').find('h3').css({
            'margin-left': '0',
            'color': bgColor
          });
        }
        // Hide flexslider nav arrows if there are 3 or less items
        var items = thisFormatter.closest('.flexslider.award-press').find('.slides > li');

        if (items.length < 4) {
          items.closest('.flexslider.award-press').addClass('item-count-3');
        // items.closest('.flexslider.award-press').find('.flex-direction-nav').hide();
        }
      });
    }
  };
})(jQuery);
